<template>
  <Dialog :dialog="dialog" title="Вы действительно хотите удалить?" :maxWidth="500">
    <slot></slot>
    <template slot="actions">
      <v-btn color="accent" flat @click="dialog.status = false">Нет</v-btn>
      <v-btn color="accent" flat @click="clickYes">Да</v-btn>
    </template>
  </Dialog>
</template>

<script>

import Dialog from '@/components/fragments/Dialog'

export default {
  components: {Dialog},
  props: {
    dialog: Object
  },
  methods: {
    clickYes () {
      this.$emit('confirm')
      this.dialog.status = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/DeleteConfirmDialog.vue